import React, { useEffect, useState } from 'react';
import { useProductApiV1 } from '../../../clients/quipli-service/product/product-api-v1';
import { Product } from '../../../clients/quipli-service/product/product';
import { toast } from '../../../util/toasts';
import { SelectVendor } from '../../vendor/vendor-order-select';
import { useVendorApi } from '../../../clients/quipli-service/vendor/vendor-api';
import { Vendor } from '../../../clients/quipli-service/vendor/vendor';
import { Spinner } from '../../../components/spinner/spinner';

export const DefaultVendorInput = ({ productId }: { productId: number }) => {
  const { getProduct, updateDefaultVendor } = useProductApiV1();
  const { getVendor } = useVendorApi();
  const [product, setProduct] = useState<Product>();
  const [vendor, setVendor] = useState<Vendor>();

  function onFetchProduct(p: Product) {
    setProduct(p);
    if (p.defaultVendorId && !vendor) {
      getVendor(p.defaultVendorId)
        .then(setVendor)
        .catch((e: any) => {
          console.error(e);
          toast('Failed to fetch vendor', 'error');
        });
    }
  }
  useEffect(() => {
    getProduct(productId)
      .then(onFetchProduct)
      .catch((e: any) => {
        console.error(e);
        toast('Failed to fetch default vendor for product', 'error');
      });
  }, [productId]);

  useEffect(() => {
    if (product && product.defaultVendorId !== vendor?.id) {
      updateDefaultVendor(productId, vendor?.id)
        .then(onFetchProduct)
        .catch((e: any) => {
          console.error(e);
          toast('Failed to update default vendor for product', 'error');
        });
    }
  }, [product, vendor]);

  return (
    <div className="item-income-account container-v2">
      {product ? <SelectVendor vendor={vendor} setVendor={setVendor} isClearable={true} /> : <Spinner />}
    </div>
  );
};
